<template>
    <div class="sort-by-container" v-show="show">
      <BaseFCPTextSelect
        :key="key"
        elementId="sort-by"
        label="Sort by"
        labelSize="xs"
        :items="options"
        v-model="context.sort"
        v-on:changed="onChanged"
      />
    </div>
</template>
<script setup>

    const model = useFCPModel()
    const { search } = useSearch(model)
    const { context, profile, searchResults, hasSearched } = model
    const { getSortOptions } = useSort(profile.value, context.value)
    const options = computed(() => {
        return searchResults.value ? getSortOptions(searchResults.value) : []
    })
    const type = computed(() => context.value.type)
    const key = computed(() => (options.value ? JSON.stringify(options.value) : 'default_key'))

    const onChanged = (event) => {
      //code snippet below was added for health informatics team to track sorting data
      _satellite.track('sort_submit')
      search()
    }

    const show = computed(() => hasSearched.value && searchResults.value && searchResults.value.length > 0)

    //We need to watch for a change in "type" in the context.  This will likely happen as a result
    //of the user changing the "I am looking for a" select box.  If this changes, we need null out the context's
    //sort value since the sort string from a practitioner search for example may not be relevant for a location
    //search.  Therefore, we need to null out and let the service start with the default.
    watch(type, (newVal, oldVal) => {
        if (newVal != oldVal) context.value.sort = ''
    })

    //getSortOptions adds/removes options (e.g. Distance, Tier) based on what the current searchResults
    //contain, so a previously selected sort value can stop existing in the list (e.g. after applying a
    //filter). A <select> whose value matches no <option> renders with nothing visibly selected, so fall
    //back to the first available option whenever that happens.
    watch(options, (newOptions) => {
        if (!newOptions || newOptions.length === 0) return
        const stillValid = newOptions.some((o) => o.value === context.value.sort)
        if (!stillValid) context.value.sort = newOptions[0].value
    })
  

</script>
  
<style scoped lang="scss">
  .sort-by-container {
    display: inline-block;
  }
</style>